module.exports = __webpack_public_path__ + "img/default-question-yes-no.67fef9ca.svg";